import UpdateFarmer from "../components/configuration/famer/UpdateFarmer";

const UpdateFarmerPage = () =>{
      

    return(
          
          <UpdateFarmer/>
    )
}

export default UpdateFarmerPage;